module.exports = __webpack_public_path__ + "img/firefox.6ab7049b.png";